module.exports = __webpack_public_path__ + "static/media/jackpot.552fe714.svg";